import { render, staticRenderFns } from "./rename-litigation.vue?vue&type=template&id=2722478d"
import script from "./rename-litigation.vue?vue&type=script&lang=js"
export * from "./rename-litigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports